import { render, staticRenderFns } from "./FormRsvpBlock.vue?vue&type=template&id=5c8a56a8"
import script from "./FormRsvpBlock.vue?vue&type=script&lang=js"
export * from "./FormRsvpBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports